import dayjs from "dayjs";

export function prettyDate(date, relativeTo) {
  const dt = dayjs(date);
  if (!relativeTo) return dt.format(`D MMM, YYYY`);

  const relativeToDt = dayjs(relativeTo);
  return dt.format(`D MMM${dt.isSame(relativeToDt, "year") ? "" : ", 'YY"}`);
}
